import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "sgg-avg-amount-wrapper",
  class: "summary-card"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "구별 평균 거래금액 랭킹", -1)
const _hoisted_3 = { class: "months-selector" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "불러오는 중...", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "ranking-list"
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"ranking-row ranking-header\"><span class=\"rank-num\">#</span><span class=\"rank-name\">구</span><span class=\"rank-amount\">평균</span><span class=\"rank-min\">최저</span><span class=\"rank-max\">최고</span><span class=\"rank-count\">건수</span></div>", 1)
const _hoisted_10 = { class: "rank-name" }
const _hoisted_11 = { class: "rank-amount" }
const _hoisted_12 = { class: "rank-min" }
const _hoisted_13 = { class: "rank-max" }
const _hoisted_14 = { class: "rank-count" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 3, 6, 12], (m) => {
        return _createElementVNode("button", {
          key: m,
          class: _normalizeClass({ active: _ctx.months === m }),
          onClick: ($event: any) => (_ctx.changeMonths(m))
        }, _toDisplayString(m) + "개월", 11, _hoisted_4)
      }), 64))
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rankingList, (item, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.sggCd,
              class: "ranking-row"
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["rank-num", { 'top3': idx < 3 }])
              }, _toDisplayString(idx + 1), 3),
              _createElementVNode("span", _hoisted_10, _toDisplayString(item.sggNm), 1),
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.toEok(item.avgAmount)) + "억", 1),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.toEok(item.minAmount)) + "억", 1),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.toEok(item.maxAmount)) + "억", 1),
              _createElementVNode("span", _hoisted_14, _toDisplayString(item.tradeCount.toLocaleString()) + "건", 1)
            ]))
          }), 128))
        ]))
  ]))
}